import { render } from "./HearingLossDataForm.vue?vue&type=template&id=1dd7faf2"
import script from "./HearingLossDataForm.vue?vue&type=script&lang=js"
export * from "./HearingLossDataForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__